module.exports = __webpack_public_path__ + "static/Realizacje-da262ccf9470f6209370a3bbd50e00f6.jpg";